import { CheckSquare, CalendarDays, BarChart2, Clock, Check } from 'lucide-react';

const FG = '#F5F1FA';
const MUTED = '#A99FB8';
const SURFACE2 = '#140C20';
const SURFACE = '#1B1029';
const VIOLET_LIGHT = '#A855F7';
const CHAMPAGNE = '#E8B96A';
const BORDER = 'rgba(255,255,255,0.08)';

const TAREFAS = [
  {
    badge: 'Protocolo',
    badgeColor: '#4ADE80',
    badgeBg: 'rgba(74,222,128,0.1)',
    badgeBorder: 'rgba(74,222,128,0.25)',
    label: 'Protocolar contestação',
    processo: '0001234-56.2025.8.21.0010',
    compromisso: '18/06/2026',
    prazoFatal: '22/06/2026',
    responsavel: 'B',
  },
  {
    badge: 'Revisar',
    badgeColor: VIOLET_LIGHT,
    badgeBg: 'rgba(168,85,247,0.1)',
    badgeBorder: 'rgba(168,85,247,0.25)',
    label: 'Revisar intimação',
    processo: '0007891-12.2024.8.21.0001',
    compromisso: '17/06/2026',
    prazoFatal: '25/06/2026',
    responsavel: 'C',
  },
  {
    badge: 'Audiência',
    badgeColor: CHAMPAGNE,
    badgeBg: 'rgba(232,185,106,0.1)',
    badgeBorder: 'rgba(232,185,106,0.25)',
    label: 'Preparar audiência de conciliação',
    processo: '0003456-78.2025.8.21.0005',
    compromisso: '20/06/2026',
    prazoFatal: '05/07/2026',
    responsavel: 'B',
  },
];

const MINI_MONTHS = ['Jun', 'Jul', 'Ago'];

export function AtividadesMockup() {
  return (
    <div
      style={{
        width: '100%',
        borderRadius: 16,
        overflow: 'hidden',
        border: `1px solid ${BORDER}`,
        background: SURFACE2,
        boxShadow:
          '0 0 0 1px rgba(109,40,217,0.15), 0 32px 80px rgba(0,0,0,0.55), 0 8px 24px rgba(109,40,217,0.12)',
        fontFamily: "'Hanken Grotesk', sans-serif",
      }}
    >
      {/* Titlebar */}
      <div
        style={{
          background: 'rgba(20,12,32,0.98)',
          borderBottom: `1px solid rgba(255,255,255,0.07)`,
          padding: '12px 18px',
          display: 'flex',
          alignItems: 'center',
          gap: 14,
        }}
      >
        <div style={{ display: 'flex', gap: 7, flexShrink: 0 }}>
          {['#FF5F56', '#FFBD2E', '#27C93F'].map((c) => (
            <span
              key={c}
              style={{
                width: 11,
                height: 11,
                borderRadius: '50%',
                background: c,
                opacity: 0.75,
                display: 'inline-block',
              }}
            />
          ))}
        </div>
        <CheckSquare size={13} color={VIOLET_LIGHT} strokeWidth={2} />
        <span style={{ fontSize: 12, fontWeight: 600, color: FG }}>
          Atividades e Prazos
        </span>
      </div>

      <style>{`
        @media (max-width: 600px) {
          .ativ-mini-grid { grid-template-columns: 1fr 1fr !important; }
          .ativ-table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }
          .ativ-table-inner { min-width: 480px; }
        }
      `}</style>
      <div style={{ padding: '16px 16px 18px', display: 'flex', flexDirection: 'column', gap: 14 }}>
        {/* Linha de mini-widgets */}
        <div className="ativ-mini-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
          {/* Widget Atividade */}
          <div
            style={{
              background: SURFACE,
              border: `1px solid ${BORDER}`,
              borderRadius: 10,
              padding: '12px 12px 10px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
              <BarChart2 size={11} color={VIOLET_LIGHT} strokeWidth={2} />
              <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase' as const, color: MUTED }}>
                Atividade
              </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              {[
                { label: 'Pendentes', value: 5, color: VIOLET_LIGHT, pct: 45 },
                { label: 'Atrasadas', value: 2, color: '#F87171', pct: 18 },
                { label: 'Resolvidas', value: 8, color: '#4ADE80', pct: 72 },
              ].map((row) => (
                <div key={row.label}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                    <span style={{ fontSize: 9, color: MUTED }}>{row.label}</span>
                    <span style={{ fontSize: 9, fontWeight: 600, color: row.color }}>{row.value}</span>
                  </div>
                  <div
                    style={{
                      height: 3,
                      borderRadius: 2,
                      background: 'rgba(255,255,255,0.06)',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        height: '100%',
                        width: `${row.pct}%`,
                        background: row.color,
                        borderRadius: 2,
                        opacity: 0.8,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Widget Produtividade */}
          <div
            style={{
              background: SURFACE,
              border: `1px solid ${BORDER}`,
              borderRadius: 10,
              padding: '12px 12px 10px',
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
              <Clock size={11} color={CHAMPAGNE} strokeWidth={2} />
              <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase' as const, color: MUTED }}>
                Produtividade
              </span>
            </div>
            <p
              style={{
                fontFamily: "'Fraunces', Georgia, serif",
                fontSize: 32,
                fontWeight: 400,
                color: FG,
                margin: 0,
                lineHeight: 1,
                letterSpacing: '-0.02em',
              }}
            >
              5
            </p>
            <p style={{ fontSize: 10, color: MUTED, margin: 0 }}>pendentes</p>
            <p style={{ fontSize: 9, color: 'rgba(169,159,184,0.5)', margin: 0 }}>
              2 atrasadas hoje
            </p>
          </div>

          {/* Widget Calendario */}
          <div
            style={{
              background: SURFACE,
              border: `1px solid ${BORDER}`,
              borderRadius: 10,
              padding: '12px 12px 10px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
              <CalendarDays size={11} color={'#4ADE80'} strokeWidth={2} />
              <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase' as const, color: MUTED }}>
                Calendário
              </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {MINI_MONTHS.map((m, i) => (
                <div
                  key={m}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '4px 6px',
                    borderRadius: 5,
                    background: i === 0 ? 'rgba(74,222,128,0.07)' : 'transparent',
                  }}
                >
                  <span style={{ fontSize: 10, color: i === 0 ? FG : MUTED, fontWeight: i === 0 ? 600 : 400 }}>{m}</span>
                  <span
                    style={{
                      fontSize: 9,
                      fontWeight: 600,
                      color: i === 0 ? '#4ADE80' : 'rgba(169,159,184,0.5)',
                    }}
                  >
                    {[3, 1, 0][i]} evento{[3, 1, 0][i] !== 1 ? 's' : ''}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Tabela de tarefas */}
        <div
          className="ativ-table-wrap"
          style={{
            background: SURFACE,
            border: `1px solid ${BORDER}`,
            borderRadius: 10,
            overflowY: 'hidden',
          }}
        >
          <div className="ativ-table-inner">
          {/* Cabecalho da tabela */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '100px 1fr 100px 100px 36px 60px',
              gap: 0,
              padding: '7px 12px',
              borderBottom: `1px solid ${BORDER}`,
              background: 'rgba(20,12,32,0.5)',
            }}
          >
            {['Tipo', 'Tarefa', 'Compromisso', 'Prazo fatal', '', 'Ação'].map((col) => (
              <span
                key={col}
                style={{
                  fontSize: 9,
                  fontWeight: 700,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase' as const,
                  color: MUTED,
                }}
              >
                {col}
              </span>
            ))}
          </div>

          {/* Linhas */}
          {TAREFAS.map((t, i) => (
            <div
              key={i}
              style={{
                display: 'grid',
                gridTemplateColumns: '100px 1fr 100px 100px 36px 60px',
                gap: 0,
                padding: '9px 12px',
                borderBottom: i < TAREFAS.length - 1 ? `1px solid ${BORDER}` : 'none',
                alignItems: 'center',
              }}
            >
              {/* Badge tipo */}
              <span
                style={{
                  fontSize: 9,
                  fontWeight: 700,
                  color: t.badgeColor,
                  background: t.badgeBg,
                  border: `1px solid ${t.badgeBorder}`,
                  borderRadius: 4,
                  padding: '2px 6px',
                  display: 'inline-block',
                  width: 'fit-content',
                }}
              >
                {t.badge}
              </span>

              {/* Label */}
              <div>
                <p
                  style={{
                    fontSize: 11,
                    fontWeight: 500,
                    color: FG,
                    margin: 0,
                    lineHeight: 1.3,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {t.label}
                </p>
                <p
                  style={{
                    fontSize: 9,
                    color: MUTED,
                    margin: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {t.processo}
                </p>
              </div>

              {/* Compromisso */}
              <span style={{ fontSize: 10, color: MUTED }}>{t.compromisso}</span>

              {/* Prazo fatal */}
              <span style={{ fontSize: 10, fontWeight: 700, color: '#F87171' }}>{t.prazoFatal}</span>

              {/* Responsavel avatar */}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 22,
                  height: 22,
                  borderRadius: '50%',
                  background: 'rgba(109,40,217,0.3)',
                  border: '1px solid rgba(168,85,247,0.3)',
                  fontSize: 9,
                  fontWeight: 700,
                  color: VIOLET_LIGHT,
                }}
              >
                {t.responsavel}
              </span>

              {/* Acao */}
              <button
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 4,
                  fontSize: 9,
                  fontWeight: 600,
                  color: '#4ADE80',
                  background: 'rgba(74,222,128,0.07)',
                  border: '1px solid rgba(74,222,128,0.2)',
                  borderRadius: 5,
                  padding: '3px 7px',
                  cursor: 'default',
                  fontFamily: 'inherit',
                }}
              >
                <Check size={9} strokeWidth={2.5} />
                Concluir
              </button>
            </div>
          ))}
        </div>
          </div>{/* /ativ-table-inner */}
      </div>
    </div>
  );
}
